<template>
    <div class="tableStyle">
      <div class="tableBox">
        <div class="dataRight">
          <div class="stateTable">
            <el-scrollbar>
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane name="first"
                  ><span slot="label"
                    ><i class="iconfont icon-shijianchuo"></i>{{$t('common.timeOfTheMonth')}}</span
                  >
                  <div v-if="'first' === activeName">
                    <MonthTime ref="monthTime"></MonthTime>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Secure from "./Secure.js";
  export default Secure;
  </script>
  
  <style lang="less" scoped>
  @import "../../../../assets/styles/Style.less";
  </style>
  